import { render, staticRenderFns } from "./amendPass.vue?vue&type=template&id=5e8d3e13"
import script from "./amendPass.vue?vue&type=script&lang=js"
export * from "./amendPass.vue?vue&type=script&lang=js"
import style0 from "./amendPass.vue?vue&type=style&index=0&id=5e8d3e13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports